import { render } from "./welcome_back.html?vue&type=template&id=6c0947d1&external"
import script from "./welcome_back.js?vue&type=script&lang=js&external"
export * from "./welcome_back.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__